// Defense-in-depth: ensure no Emergent branding badge ever renders, even if
// platform scripts attempt to inject or revive one.
function killEmergentBadge() {
  const selectors = [
    "#emergent-badge",
    'a[href*="emergent.sh"]',
    'a[id*="emergent-badge"]',
  ];
  selectors.forEach((sel) => {
    document.querySelectorAll(sel).forEach((el) => {
      el.style.setProperty("display", "none", "important");
      el.style.setProperty("visibility", "hidden", "important");
      el.style.setProperty("opacity", "0", "important");
      el.style.setProperty("pointer-events", "none", "important");
      el.setAttribute("aria-hidden", "true");
    });
  });
  // Also remove any text node literally reading "Made with Emergent"
  document.querySelectorAll("a, div, span, p").forEach((el) => {
    const txt = (el.textContent || "").trim().toLowerCase();
    if (txt === "made with emergent") {
      el.style.setProperty("display", "none", "important");
    }
  });
}

if (typeof window !== "undefined") {
  // Run immediately if DOM is already parsed, otherwise on DOMContentLoaded.
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", killEmergentBadge);
  } else {
    killEmergentBadge();
  }
  // Re-kill on any future DOM mutations (in case the platform script re-injects).
  try {
    const obs = new MutationObserver(() => killEmergentBadge());
    obs.observe(document.documentElement, { childList: true, subtree: true });
  } catch {
    /* no-op */
  }
}
